/** The upload queue and the phone's signal, for the tiles of Board 15 B. */
import { useEffect, useState } from 'react'
import { uploadQueue, type QueueItem } from './upload-queue.js'

export function useQueue(): QueueItem[] {
  const [items, setItems] = useState<QueueItem[]>(() => uploadQueue().items())
  useEffect(() => uploadQueue().subscribe(setItems), [])
  return items
}

export function useOnline(): boolean {
  const [online, setOnline] = useState(() => typeof navigator === 'undefined' || navigator.onLine !== false)
  useEffect(() => {
    const on = () => setOnline(true)
    const off = () => setOnline(false)
    window.addEventListener('online', on)
    window.addEventListener('offline', off)
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off) }
  }, [])
  return online
}
